// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__16vyI","content":"GlobalSearch_content__4ATeF"};